import {
  Category,
  CategoryApi,
  PriceInfo,
  PriceInfoApi,
  Product,
  ProductApi,
  ProductPromotion,
  ProductPromotionApi,
} from 'interfaces/types/Ecommerce'
import { isDefined } from 'utils/ecommerce'

export const ecommerceDataFormatter = {
  formatProductPromotion: (
    productPromotionApi?: ProductPromotionApi,
  ): ProductPromotion | null => {
    if (!productPromotionApi) return null

    return {
      id: productPromotionApi.id || 0,
      name: productPromotionApi.name || '',
      thumbnail: productPromotionApi.thumbnail || '',
      expirationDate: productPromotionApi.expiration_date || '',
    }
  },
  formatPriceInfo: (priceInfoApi?: PriceInfoApi): PriceInfo | null => {
    if (!priceInfoApi) return null
    return {
      final: priceInfoApi.final || 0,
      regular: priceInfoApi.regular || 0,
      discountPercent: priceInfoApi.discount_percent || 0,
    }
  },
  formatCategory: function (
    data: CategoryApi,
    parentId?: number,
    parentFullSlug?: string,
  ): Category {
    const currentFullSlug = parentFullSlug
      ? parentFullSlug + '/' + data.slug
      : data.slug
    const children =
      data?.children?.map?.((childCategory) => {
        return ecommerceDataFormatter.formatCategory(
          childCategory,
          data.id,
          currentFullSlug,
        )
      }) || []
    return {
      id: data?.id,
      name: data?.name || '',
      logo: data?.logo || '',
      slug: data?.slug || '',
      fullSlug: currentFullSlug || '',
      children,
      //   backgroundColor: data.color || theme.colors.teal50,
      parentId: parentId || 0,
      products: (data.products?.map(this.formatProduct) as Product[]) || [],
    }
  },
  formatProduct: (productApi?: ProductApi): Product | null => {
    if (!productApi) return null
    const defaultPriceInfo = {
      final: 0,
      regular: 0,
      discountPercent: 0,
    }
    return {
      id: productApi.id || 0,
      price: productApi.price
        ? ecommerceDataFormatter.formatPriceInfo(productApi.price) ||
          defaultPriceInfo
        : defaultPriceInfo,
      thumbnail: productApi.thumbnail || '',
      name: productApi.name || '',
      averageRating: Number((productApi.average_rating || 0).toFixed(2)),
      reviewsCount: productApi.reviews_count || 0,
      tag: productApi.tag || null,
      sku: productApi.sku || '',
      slug: productApi.slug || '',
      images: productApi.images || [],
      tags: productApi.tags || [],
      unit: productApi.unit || '',
      brand: productApi.brand
        ? {
            name: productApi.brand.name || '',
            image: productApi.brand.image || '',
            slug: productApi.brand.slug || '',
            productsCount: productApi.brand.products_count || 0,
          }
        : null,
      description: productApi.description || '',
      productPromotions:
        productApi.product_promotions
          ?.map?.(ecommerceDataFormatter.formatProductPromotion)
          .filter(isDefined) || [],
      // categories:
      //   productApi.categories
      //     ?.map?.((c) => ecommerceDataFormatter.formatCategory(c))
      //     .filter(isDefined) || [],
      isInStock: productApi?.is_in_stock || false,
      isAffiliateProduct: productApi?.is_affiliate_product || false,
      affiliates:
        productApi.affiliates?.map((a) => ({
          channelCode: a.channel_code || '',
          price: a.price,
          url: a.url,
        })) || [],
    }
  },
}
